import { lazy, type ComponentType } from 'react';
import { ACTIVE_THEME_ID } from '../config/theme/theme';
import { WarmBroadsheetFooter } from '../pages/themes/warm-broadsheet/Footer';

// Footer needs no custom hook (only currentYear + useJournalSettings()) -- this file is
// directly the theme-select shim; each theme's own Footer is fully independent.
// Only the active theme's footer ships eagerly (this file is part of the
// always-loaded entry bundle); the other 4 themes are dynamic imports so
// their code is never fetched/parsed unless VITE_THEME selects them (fixes
// unused-JS-shipped-on-every-load from the performance audit).
const THEME_FOOTERS: Record<string, ComponentType<any>> = {
  'clinical-modern': lazy(() => import('../pages/themes/clinical-modern/Footer').then(m => ({ default: m.ClinicalModernFooter }))),
  'classic-academic': lazy(() => import('../pages/themes/classic-academic/Footer').then(m => ({ default: m.ClassicAcademicFooter }))),
  'minimal-scandinavian': lazy(() => import('../pages/themes/minimal-scandinavian/Footer').then(m => ({ default: m.MinimalScandinavianFooter }))),
  'field-notes': lazy(() => import('../pages/themes/field-notes/Footer').then(m => ({ default: m.FieldNotesFooter }))),
};
const Footer = THEME_FOOTERS[ACTIVE_THEME_ID] || WarmBroadsheetFooter;

export default Footer;
